<div class="switch">
  @for (item of choices; track item; let isFirst = $first) {
    <div [class.switch__disabled]="item.disabled">
      <input
        class="sr-only"
        [name]="hash"
        [id]="item.id + '_' + hash"
        type="radio"
        (change)="handleChange($event, item)"
      />
      <label
        [for]="item.id + '_' + hash"
        #selected
        [class.switch__label]="true"
        >{{ item.label }}</label
      >
    </div>
  }

  @if (indicatorLabel; as label) {
    <div
      [class]="'switch__indicator ' + getSelectedChoiceClass()"
      [style.width]="label.offsetWidth + 'px'"
      [style.transform]="'translateX(' + label.offsetLeft + 'px)'"
    ></div>
  }
</div>
